import React from 'react';

import { humanCase } from '@paragon/utilities';

import { useAppSelector } from '../../hooks';
import { TooltipTextContent } from './common';

export function FeatureAreaTooltip(props: { guid: string }) {
  const featureArea = useAppSelector((state) => {
    for (const featurePatternContainer of Object.values(state.layout.featurePatternContainers)) {
      for (const featureArea of featurePatternContainer.featureAreas) {
        if (featureArea.guid === props.guid) {
          return featureArea;
        }
      }
    }
  });

  if (featureArea == null) {
    console.warn('Unable to find feature area for tooltip.');
    return null;
  }

  return <TooltipTextContent text={humanCase(featureArea.featureType)} />;
}
